import React from 'react'
import { getUserRepos, getUserRepoStatistics } from '../helpers'
import Loader from './Loader'
// This function will return a component that is built
// from 5 progress elemnts that display the top 5 languages
// used by a user and their percentage of their total repos
export default function CodeGraph({ username, count = 5 }) {
    // use effect to get the repos from github under the username rach0022 (me)
    const [repos, setRepos] = React.useState(null)
    const [loading, setLoading] = React.useState(true) //loading starts off as true

    React.useEffect(() => {
        getUserRepos({ username })
            .then(setRepos)
            .then((setLoading(false)))
            .catch(err => console.error('Error fetching user repos' + err))
        // .finally(setLoading(false)) // stop the loading once the data is retrieved
    }, [username, setRepos, setLoading])

    // if we are loading return the loader
    if (loading || !repos) return <Loader />

    const codeMap = getUserRepoStatistics(repos)

    // get top 5 entries from map by first creating an array from the map and mapping each item
    // to an object {key, value} then sort the array based on the .value (descending sort)
    let sortedCodeElements = Array.from(codeMap)
        .map(([key, value]) => ({ key, value }))
        .sort((a, b) => b.value - a.value)

    // map the sorted values to progress elements, only showing the first 5 excluding the total category
    // maybe change to its own component? 
    const codeGraphElements = sortedCodeElements.map(item => {
        if (!item.key) return null
        return (
            <div className="code-graph-item" key={item.key} title={`${item.value}/${repos.length} Total Projects`}>
                <p className="title is-6 graph-label">{item.key}</p>
                <progress className="progress is-danger" value={item.value} max={repos.length} />
            </div>
        )
    })

    return (
        <div className="CodeGraph">
            {/* Only show the amount of elements specified default to 5 */}
            {codeGraphElements.slice(0, count + 1)}
        </div>
    )
}
